"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compact;

var _filter = _interopRequireDefault(require("./filter.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Trim out all falsy values from an array.
function compact(array) {
  return (0, _filter.default)(array, Boolean);
}